import { Location, Module } from "./constants";

export const getAnalyticsLocationFromPath = (path: string): Location | null => {
  if (!path) {
    return null;
  }

  if (path.includes("/playlists")) {
    return Location.Playlists;
  }
  if (path.includes("/dashboard")) {
    return Location.Home;
  }
  if (path.includes("/library")) {
    return Location.Library;
  }
  if (path.includes("/results")) {
    return Location.Library;
  }
  if (path.includes("/community")) {
    return Location.Community;
  }
  if (path.includes("/challenges")) {
    return Location.Community;
  }
  if (path.includes("/post")) {
    return Location.Community;
  }
  if (path.includes("/account")) {
    return Location.Account;
  }
  if (path.includes("/saved")) {
    return Location.Saved;
  }
  if (path.includes("/history")) {
    return Location.History;
  }
  if (path.includes("/profile")) {
    return Location.Profile;
  }
  if (path.includes("/achievements")) {
    return Location.Achievements;
  }

  return null;
};

export function getAnalyticsModuleFromPath(pathname: string): Module | null {
  if (!pathname) {
    return null;
  }

  if (pathname.includes("/playlists/created")) {
    return Module.MyPlaylists;
  }
  if (pathname.includes("/playlists/following")) {
    return Module.FollowedPlaylists;
  }
  if (pathname.includes("/playlists/steezy")) {
    return Module.SteezyPlaylists;
  }

  return null;
}
